


const PIN_EXPIRY_MS = 8 * 60 * 60 * 1000; 
 
document.addEventListener('DOMContentLoaded', function () {
  if (window.Shopify && Shopify.designMode) return;
 
  const overlay = document.getElementById('pincode-overlay');
  const input = document.getElementById('pincodeInput');
  const checkBtn = document.getElementById('pincodeCheckBtn');
  const closeBtn = document.getElementById('pincodeClose');
  const statusEl = document.getElementById('pincodeStatus');
 
  const STORAGE_KEY = 'mkh_pincode_data';
  const SHOP_NAME = "paulandmike-co.myshopify.com";
  const PRODUCT_ID = "8983348805861";
 
  function readStorage() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }
 
  function writeStorage(obj) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
      return true;
    } catch (err) {
      console.error('localStorage write failed:', err);
      return false;
    }
  }
 
  function showPopup() {
    overlay.style.display = 'flex';
    input.focus();
  }
 
  function hidePopup() {
    overlay.style.display = 'none';
  }
 
  function showStatus(msg, type) {
    statusEl.textContent = msg;
    statusEl.className = 'pincode-status ' + (type || '');
  }
 
  async function checkPincode(pin) {
    try {
      const res = await fetch('https://zipcode.ens.enterprises/api/allCollectionProduct', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shopName: SHOP_NAME,
          ZipCodeget: pin,
          productId: PRODUCT_ID
        })
      });
 
      const data = await res.json();
      const resText = JSON.stringify(data).toLowerCase();
 
      if (resText.includes('flag1')) {
        const expires = Date.now() + PIN_EXPIRY_MS;
        const saved = writeStorage({ verified: true, pincode: pin, expires });
 
        if (saved) {
          showStatus('Delivery available ✅', 'success');
          setTimeout(() => hidePopup(), 700);
        } else {
          showStatus('Verified, but could not save. Try again.', 'error');
        }
      } else {
        showStatus('Delivery not available ❌', 'error');
      }
    } catch (err) {
      console.error('API error:', err);
      showStatus('Error checking pincode', 'error');
    }
  }
 
  function handleAddToCartClick(e) {
    const stored = readStorage();
    const now = Date.now();
 
    const isValid = stored.verified && stored.expires > now;
 
    if (isValid) {
      return; 
    }
 
    localStorage.removeItem(STORAGE_KEY);
 
    e.preventDefault();
    e.stopImmediatePropagation();
    showPopup();
  }
 
  function bindButtons() {
    const addToCartBtns = document.querySelectorAll(' #CollectionGrid .incubate-collections-add-to-cart-add-to-cart-button');
    addToCartBtns.forEach(btn => {
      btn.addEventListener('click', handleAddToCartClick, true);
    });
  }
 
  bindButtons();
 
  const observer = new MutationObserver(() => bindButtons());
  observer.observe(document.body, { childList: true, subtree: true });
 
  checkBtn.addEventListener('click', () => {
    const pin = input.value.trim();
    if (!/^[1-9][0-9]{5}$/.test(pin)) {
      showStatus('Enter valid 6-digit PIN', 'error');
      return;
    }
    showStatus('Checking...', '');
    checkPincode(pin);
  });
 
  closeBtn.addEventListener('click', hidePopup);
});
 
 

function getAllGatedButtons() {
  return [
    document.querySelector('.add-to-cart'),
    document.querySelector('.shopify-payment-button__button'),
    document.querySelector('.payment-buttons button'),
    document.querySelector('shopify-buy-it-now-button button')
  ].filter(Boolean);
}
 
const enableProductButtons = () => {
  const deliverySection = document.getElementById('delivery-checker-section');
  if (deliverySection) {
    deliverySection.style.display = 'none';
    deliverySection.style.visibility = 'hidden';
  }
 
  getAllGatedButtons().forEach(btn => {
    btn.removeAttribute('disabled');
    btn.style.cursor = 'pointer';
    btn.style.pointerEvents = 'auto';
    btn.style.opacity = '1';
  });
};
 
const disableProductButtons = () => {
  const deliverySection = document.getElementById('delivery-checker-section');
  if (deliverySection) {
    deliverySection.style.display = 'block';
    deliverySection.style.visibility = 'visible';
  }
 
  getAllGatedButtons().forEach(btn => {
    btn.setAttribute('disabled', 'disabled');
    btn.style.cursor = 'not-allowed';
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.5';
  });
};

function getVerifiedState() {
  const now = Date.now();
 
  const stored = JSON.parse(localStorage.getItem('mkh_pincode_data') || '{}');
  if (stored.verified && stored.expires > now) {
    return { verified: true, pincode: stored.pincode };
  }
  if (stored.verified) {
    // expired -> clean it up
    localStorage.removeItem('mkh_pincode_data');
  }
 
  return null;
}
 
function setVerifiedPincode(pin) {
  localStorage.setItem('mkh_pincode_data', JSON.stringify({
    verified: true,
    pincode: pin || null,
    expires: Date.now() + PIN_EXPIRY_MS
  }));
}
 
function getVerifiedPincode() {
  return getVerifiedState();
}
 
function checkAllVerification() {
  const state = getVerifiedState();
  if (state && state.verified) {
    enableProductButtons();
  } else {
    disableProductButtons();
  }
}
 
checkAllVerification();
setInterval(checkAllVerification, 1000);
 
window.addEventListener('storage', (e) => {
  if (e.key === 'mkh_pincode_data') {
    checkAllVerification();
  }
});
 
document.addEventListener('DOMContentLoaded', function () {
  const successMessagePincode = 'We deliver to your zipcode.'; // success text only
 
  const interval = setInterval(() => {
    const msgElement = document.querySelector('#msg_Value');
    if (!msgElement) {
      return;
    }
 
    const textMatch = msgElement.innerText.trim() === successMessagePincode;
 
    if (textMatch) {
      setVerifiedPincode(null);
      checkAllVerification();
      clearInterval(interval);
    }
  }, 1000);
});
 
 
bindAddToCartButtons();
waitForElement('.incubate-collections-add-to-cart-widget.cbb-desktop-view', bindAddToCartButtons);
 
const collectionObserver = new MutationObserver(() => bindAddToCartButtons());
collectionObserver.observe(document.body, { childList: true, subtree: true });
 